import httpClient from '../api/httpClient'

export const getTimelineByPersonId = async (payload) => {
  const endpoint = `reftimelines?personId=${payload}`
  return httpClient.get(endpoint)
}

export const addTimeline = async (payload) => {
  const endpoint = '/reftimelines/create'
  return httpClient.post(endpoint, payload)
}

export const editTimeline = async (payload) => {
  const endpoint = `/reftimelines/update`
  return httpClient.put(endpoint, payload)
}

export const deleteTimeline = async (payload) => {
  const endpoint = `/reftimelines/delete`
  return httpClient.delete(endpoint, { data: { Id: payload }})
}

export default {
  addTimeline,
  editTimeline,
  deleteTimeline,
  getTimelineByPersonId
}
